<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
  <button type="button" class="close" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label>Nom <span class="text-danger">*</span></label>
          <input type="text" class="form-control" formControlName="nom" placeholder="Nom de la charge">
          <span *ngIf="submit && f.nom.errors?.required" class="text-danger">Le nom est obligatoire</span>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label>Description</label>
          <textarea class="form-control" formControlName="description" rows="2" placeholder="Description"></textarea>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Mode de répartition</label>
          <select class="form-control" formControlName="modeRepartition">
            <option *ngFor="let m of modesRepartition" [value]="m.value">{{ m.label }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Récurrence</label>
          <select class="form-control" formControlName="recurrence">
            <option *ngFor="let r of recurrences" [value]="r.value">{{ r.label }}</option>
          </select>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Montant total <span class="text-danger">*</span></label>
          <input type="number" class="form-control" formControlName="montantTotal" placeholder="0">
        </div>
      </div>
      <div class="col-md-6" *ngIf="form.get('modeRepartition').value === 'FIXE'">
        <div class="form-group">
          <label>Montant fixe par lot</label>
          <input type="number" class="form-control" formControlName="montantFixe" placeholder="0">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Date début</label>
          <input type="date" class="form-control" formControlName="dateDebut">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Date fin</label>
          <input type="date" class="form-control" formControlName="dateFin">
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <div class="custom-control custom-switch">
            <input type="checkbox" class="custom-control-input" id="actifSwitch" formControlName="actif">
            <label class="custom-control-label" for="actifSwitch">Actif</label>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="onClose()">Fermer</button>
  <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="onSubmit()">Enregistrer</button>
</div>
